import { ACTION_USER_LIST, ACTION_USER_VIEW } from "../actions/users";
import { ACTION_COMPANY_LIST, ACTION_COMPANY_SELECT, ACTION_COMPANY_VIEW } from "../actions/companies";
import { ACTION_LOCATION_LIST, ACTION_LOCATION_VIEW } from "../actions/locations";
import { ACTION_USER_COMPANY_LIST } from "../actions/user-companies";
import { ACTION_USER_REGION_LIST } from "../actions/user-regions";

let initialReducer = {
    users: {
        list: {
            rows: [],
            total: 0,
            pagination: [],
        },
        view: {
            profile: '',
            name: '',
            username: '',
        }
    },
    companies: {
        list: {
            rows: [],
            total: 0,
            pagination: [],
        },
        view: {
            name: '',
        },
        select: []
    },
    locations: {
        list: {
            rows: [],
            total: 0,
            pagination: [],
        },
        view: {
            companyId: '',
            categoryId: '',
            regionId: '',
            code: '',
            name: '',
        }
    },
    userCompanies: {
        list: {
            rows: [],
            total: 0,
            pagination: [],
        }
    },
    userRegions: {
        list: {
            rows: [],
            total: 0,
            pagination: [],
        }
    },
}

let RegisterReducers = (state = initialReducer, action) => {
    switch (action.type) {
        case ACTION_USER_LIST.type:
            return {
                ...state,
                users: {
                    list: {
                        rows: action.payload.rows,
                        total: action.payload.total,
                        pagination: action.payload.pagination,
                    },
                    view: state.users.view,
                }
            };
        case ACTION_USER_VIEW.type:
            return {
                ...state,
                users: {
                    list: state.users.list,
                    view: {
                        profile: action.payload.profile,
                        name: action.payload.name,
                        username: action.payload.username
                    },
                },
            };
        case ACTION_COMPANY_LIST.type:
            return {
                ...state,
                companies: {
                    list: {
                        rows: action.payload.rows,
                        total: action.payload.total,
                        pagination: action.payload.pagination,
                    },
                    view: state.companies.view,
                    select: state.companies.select,
                }
            };
        case ACTION_COMPANY_VIEW.type:
            return {
                ...state,
                companies: {
                    list: state.companies.list,
                    view: {
                        name: action.payload.name,
                    },
                    select: state.companies.select,
                },
            };
        case ACTION_COMPANY_SELECT.type:
            return {
                ...state,
                companies: {
                    list: state.companies.list,
                    view: state.companies.view,
                    select: action.payload
                }
            };
        case ACTION_LOCATION_LIST.type:
            return {
                ...state,
                locations: {
                    list: {
                        rows: action.payload.rows,
                        total: action.payload.total,
                        pagination: action.payload.pagination,
                    },
                    view: state.locations.view,
                }
            };
        case ACTION_LOCATION_VIEW.type:
            return {
                ...state,
                locations: {
                    list: state.locations.list,
                    view: {
                        companyId: action.payload.companyId,
                        categoryId: action.payload.categoryId,
                        regionId: action.payload.regionId,
                        code: action.payload.code,
                        name: action.payload.name,
                    },
                },
            };
        case ACTION_USER_COMPANY_LIST.type:
            return {
                ...state,
                userCompanies: {
                    list: {
                        rows: action.payload.rows,
                        total: action.payload.total,
                        pagination: action.payload.pagination,
                    },
                }
            };
        case ACTION_USER_REGION_LIST.type:
            return {
                ...state,
                userRegions: {
                    list: {
                        rows: action.payload.rows,
                        total: action.payload.total,
                        pagination: action.payload.pagination,
                    },
                }
            };
        default:
            return state;
    }
}

export default RegisterReducers